import { render, staticRenderFns } from "./marqueue.vue?vue&type=template&id=3c622ee6&scoped=true&"
import script from "./marqueue.vue?vue&type=script&lang=js&"
export * from "./marqueue.vue?vue&type=script&lang=js&"
import style0 from "./marqueue.vue?vue&type=style&index=0&id=3c622ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c622ee6",
  null
  
)

export default component.exports